import { byteLengthFromDataUri } from '@/utils/helper';
import { useCallback, useRef } from 'react';
import { launchImageLibrary } from 'react-native-image-picker';

type AvatarPickerOnChange = (value: { uri: string; fileSize?: number }) => void;

export function useAvatarPicker() {
  const busyRef = useRef(false);

  return useCallback(async (onChange: AvatarPickerOnChange) => {
    if (busyRef.current) return;
    busyRef.current = true;
    try {
      const result = await launchImageLibrary({ mediaType: 'photo', selectionLimit: 1 });
      if (result.didCancel || result.errorCode) return;
      const asset = result.assets?.[0];
      if (!asset?.uri) return;
      const fileSize = asset.fileSize ?? byteLengthFromDataUri(asset.uri);
      onChange({ uri: asset.uri, fileSize });
    } finally {
      busyRef.current = false;
    }
  }, []);
}
